import Images from "../../utils/Images";

export default function BannerImage() {
  const alt =
    "Every journey deserves a safety net. That's why we insure moments, not just smiles.";

  return (
    <section className="w-full">
      <img
        src={Images.hero_mobile_three}
        alt={alt}
        className="block w-full h-auto md:hidden"
      />
      <img
        src={Images.hero_img_web_three}
        alt={alt}
        className="hidden w-full h-auto md:block"
      />
    </section>
  );
}
